import "./index.scss"
import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const UpdateCard = ({ update }) => {
  const { datePosted, introText, slug, title, featuredImage } = update

  const cardImage = getImage(featuredImage)

  return (
    <div className="update-card">
      <Link to={`/updates/${slug}`}>
        <div className="col-md-12 update-card__wrapper">
          {cardImage && (
            <div className="update-card__image">
              <GatsbyImage image={cardImage} alt="" />
            </div>
          )}

          <div className="update-card__content">
            <div className="update-card__data">
              <span className="update-card__date">{datePosted}</span>
            </div>

            <Link to={`/updates/${slug}`} className="update-card__title">
              {title}
            </Link>

            <div className="update-card__description">{introText}</div>

            <div className="update-card__link">
              <Link to={`/updates/${slug}`}>Read more</Link>
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default UpdateCard
